module.exports = {"140671400":"山西朔州经济开发区街道筹备处"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140671.json
// module id = 320
// module chunks = 0